export default __webpack_public_path__ + "static/2-2c9362c32a6e8082a2af2eb814977e28.png";